import { FlexiButton } from "appworks/graphics/elements/flexi-button";
import { ButtonControl } from "appworks/ui/controls/standard/button/button-control";
import { gamevy } from "gamevy/gamevy";
import { gamevyModel } from "gamevy/gamevy-model";

export class GamevyCustomLobbyControl extends ButtonControl {
    constructor(protected button: FlexiButton) {
        super(button);

        if (!gamevyModel.lobbyUrl) {
            button.setVisible(false);
        }
    }

    protected onClick(): void {
        gamevy.commonUI.handleEvent("game_events/go_to_lobby" as any, null);
    }
}
